module.exports = __webpack_public_path__ + "static/media/challenge-island.c3fefbbe.png";